import { render, staticRenderFns } from "./HistoricoConfiguracaoCaixaPostal.vue?vue&type=template&id=17008b6b&"
import script from "./HistoricoConfiguracaoCaixaPostal.vue?vue&type=script&lang=js&"
export * from "./HistoricoConfiguracaoCaixaPostal.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoConfiguracaoCaixaPostal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports